import { render } from "./SingleComment.vue?vue&type=template&id=5c1772ac"
import script from "./SingleComment.vue?vue&type=script&lang=js"
export * from "./SingleComment.vue?vue&type=script&lang=js"

import "./SingleComment.vue?vue&type=style&index=0&id=5c1772ac&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__